import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss']
})
export class StarRatingComponent implements OnInit {
  @Input() noOfStars = 5;
  @Input() starRate = 0;
  @Input() starColor = '#3195e0';
  public numberOfStars = [];
  constructor() {
    // this.numberOfStars = Array.from(Array(this.noOfStars).keys());
  }

  ngOnInit() {
    this.numberOfStars = Array.from(Array(this.noOfStars).keys());
  }

}
